import { url } from '@tencent/wphk-base-utils';
import { UrlParams } from '../types';

/**
 * 本页面统一从url模块获取qryParams，便于管理
 */
export const getUrlParamByKey = (paramKey: UrlParams) => url.getUrlParam(paramKey) || '';
